import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import { fetchClientDetails } from "../api";
import HeaderPortal from "components/portal/header-portal";
import { DropdownMenuItem } from "ui/components/dropdown-menu";
import { PermissionControlledInput } from "permissions/components/input";
import EditItemButton from "components/buttons/edit";
import { useFetch } from "@/hooks/useFetch";
import ClientInfoCard from "components/client/profile-card";
import ClientSurveyCardSection from "./card-section";
import ClientSurveys from "./survey";
import PerformanceDetailsSidebar from "@/modules/performance/overview/components/performance-details-sidebar";

const ClientDetail = () => {
    const { clientId } = useParams();
    const [selectedCard, setSelectedCard] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleCardClick = (cardData) => {
        setSelectedCard(cardData);
        setIsSidebarOpen(true);
    };

    const handleCloseSidebar = () => {
        setIsSidebarOpen(false);
        setSelectedCard(null);
    };

    const { data: clientDetails, isLoading } = useFetch({
        queryKey: ["client-details", clientId],
        queryFn: () => fetchClientDetails({ clientId }),
    });

    if (isLoading || !clientDetails) {
        return null;
    }

    return (
        <div className="flex-1">
            <EvtHeader title="Client Details" />
            <ClientInfoCard client={clientDetails} />
            <ClientSurveyCardSection onClick={handleCardClick} />
            <ClientSurveys />
            <HeaderPortal>
                <PermissionControlledInput
                    rule="update:*"
                    collection="clients"
                >
                    <EditItemButton href={`/crm/clients/${clientId}/edit`} />
                </PermissionControlledInput>
            </HeaderPortal>
            <PerformanceDetailsSidebar
                isOpen={isSidebarOpen}
                onClose={handleCloseSidebar}
                cardData={selectedCard}
            />
        </div>
    );
};

export default ClientDetail;
